import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Check if user is already logged in on component mount
    useEffect(() => {
        const user = localStorage.getItem("user");
        if (user) {
            setCurrentUser(JSON.parse(user));
        }
        setLoading(false);
    }, []);

    // Login function with hard-coded credentials
    const login = (email, password) => {
        // Hard-coded credentials for demo purposes
        const validCredentials = [
            { email: "agent@agentsamurai.com", password: "password123", name: "Zulhilmi" },
            { email: "demo@agentsamurai.com", password: "demo2023", name: "Midzi" }
        ];

        // Check if provided credentials match any valid pair
        const matchedUser = validCredentials.find(
            (user) => user.email === email && user.password === password
        );

        if (matchedUser) {
            // Create user object with additional fields
            const user = {
                id: Math.floor(Math.random() * 1000),
                email: matchedUser.email,
                name: matchedUser.name,
                role: "agent",
                lastLogin: new Date().toISOString()
            };

            // Save to local storage and update state
            localStorage.setItem("user", JSON.stringify(user));
            setCurrentUser(user);
            return Promise.resolve(user);
        } else {
            // Return rejected promise for invalid credentials
            return Promise.reject(new Error("Invalid email or password"));
        }
    };

    // Logout function
    const logout = () => {
        localStorage.removeItem("user");
        setCurrentUser(null);
    };

    const value = {
        currentUser,
        login,
        logout,
        isAuthenticated: !!currentUser,
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};